import { apiFetchJson } from "./apiClient";

export interface UserDetails {
  id: number;
  username: string;
  email: string;
  name: string;
}

export interface DashboardAssetStats {
  total: number;
  recent: number;
}

export interface DashboardCampaignStats {
  total: number;
  active_sessions: number;
}

export interface DashboardCharacterStats {
  total: number;
}

export interface DashboardSessionStats {
  total: number;
  active: number;
  played: number;
}

export interface DashboardRecentSession {
  id: number;
  campaign_id: number;
  campaign_name: string;
  status: string;
  theme: string;
  started_at: string | null;
  updated_at: string;
}

export interface DashboardRecentCampaign {
  id: number;
  name: string;
  type: string;
  setting: string;
  updated_at: string;
}

export interface DashboardStats {
  assets: DashboardAssetStats;
  campaigns: DashboardCampaignStats;
  characters: DashboardCharacterStats;
  sessions: DashboardSessionStats;
  recent_sessions: DashboardRecentSession[];
  recent_campaigns: DashboardRecentCampaign[];
}

export class UserService {
  /**
   * Get user details by ID
   */
  static async getUserById(userId: number): Promise<UserDetails> {
    return apiFetchJson(`/api/protected/user/${userId}`);
  }

  /**
   * Get multiple users by their IDs
   */
  static async getUsersByIds(userIds: number[]): Promise<UserDetails[]> {
    return apiFetchJson("/api/protected/users/bulk", {
      method: "POST",
      body: JSON.stringify({ userIds }),
    });
  }

  /**
   * Get current user profile
   */
  static async getCurrentUserProfile(): Promise<UserDetails> {
    return apiFetchJson("/api/protected/user/profile");
  }

  /**
   * Get dashboard statistics for the authenticated user
   */
  static async getDashboardStats(): Promise<DashboardStats> {
    return apiFetchJson("/api/protected/dashboard/stats");
  }
}
